module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"show_subscription_modal","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"label":{"type":"string"},"level":{"type":"string"},"levelID":{"type":"string","description":"Actually the level slug."}},"required":["user","label"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/show_subscription_modal.json
// module id = 574
// module chunks = 100